import React, { useMemo } from 'react';

import { useKioskManager } from '../../../hooks/useKioskManager';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import styles from './searchInput.module.scss';

type SearchInputProps = {
  placeholder?: string;
  value: string;
  onChange?: (value: string | undefined) => void;
  onFocus: () => void;
  onCancel?: () => void;
  hideSearchIcon?: boolean;
  disabled?: boolean;
  outsideClickRef?: React.RefObject<HTMLDivElement>;
  searchInputRef?: React.RefObject<HTMLInputElement>;
};

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder,
  value,
  onChange,
  onFocus,
  onCancel,
  hideSearchIcon, // input for campus navigation
  disabled,
  outsideClickRef,
  searchInputRef,
}) => {
  const { kiosk, kioskMode } = useKioskManager();

  const icon = useMemo(
    () => (value ? IconType.CLOSE : IconType.SEARCH),
    [value],
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onChange && onChange(e.currentTarget.value);
  };

  const handleClearSearch = () => {
    onCancel && onCancel();
    searchInputRef?.current?.focus();
  };

  return (
    <div
      className={`${styles.container} ${
        kiosk && kioskMode && styles[kiosk.model]
      }`}
      ref={outsideClickRef}
    >
      <input
        className={`${styles.search} ${disabled && styles.disabled}`}
        value={value || ''}
        onChange={handleSearchChange}
        placeholder={placeholder}
        onFocus={onFocus}
        ref={searchInputRef}
        type="text"
        disabled={disabled}
        autoComplete="off"
      />
      {!(hideSearchIcon && icon === IconType.SEARCH) && (
        <div className={styles.icon} onClick={() => handleClearSearch()}>
          <Icon
            icon={icon}
            size="full"
            ariaLabel={value ? 'Close' : 'Search'}
          />
        </div>
      )}
    </div>
  );
};

export default SearchInput;
